import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";

const Wallet = () => {
  const [initialValues, setInitialValues] = useState({
    "wallet-options": false,
    "minimum-usable-amount": "",
  });
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState<any>(null);

  const fetchWalletSettings = async () => {
    try {
      const res = await generalSettings.getByKey({
        state: "wallet",
        id: "customer-wallet-setting", // Changed to match your API key
        showErr: false,
      });
      if (res) {
        console.log("Wallet settings response:", res);
        setInitialValues({
          "wallet-options": res?.infos?.status || false, // Access status from infos
          "minimum-usable-amount": res?.value?.toString() || "", // Value is directly on res
        });
        setExist(res);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchWalletSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const payload = {
        key: "customer-wallet-setting", // Match the API key
        value: values["minimum-usable-amount"] || 0, // Value as number
        infos: {
          status: values["wallet-options"], // Status in infos object
        },
      };

      if (exist?.id) {
        await generalSettings.update({
          state: "wallet",
          data: payload,
          id: exist.id,
        });
        toast.success("Wallet settings updated successfully!");
      } else {
        await generalSettings.create({ state: "wallet", data: payload });
        toast.success("Wallet settings saved successfully!");
      }

      fetchWalletSettings();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update wallet settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Customer Wallet Setting" />
          <Wrapper>
            <Column>
              <Row>
                <div style={{ flex: 1 }}>
                  <Fields.Switch name="wallet-options" label="Wallet Options" />
                </div>

                <div style={{ flex: 4 }}>
                  <Fields.Input
                    name="minimum-usable-amount"
                    label="Minimum Usable Amount in Wallet (NPR)"
                    placeholder="Rs 100"
                    type="number" // Added type number for better input handling
                  />
                </div>
              </Row>

              <div style={{ marginTop: 16, textAlign: "right" }}>
                <Button
                  title={exist ? "Update" : "Save"}
                  type="submit"
                  loading={loading}
                  justify="end"
                />
              </div>
            </Column>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default Wallet;
